import useGenericIntegrations from '../generic/useGenericIntegrations';
import useIntegrations from './useIntegrations';

const useGetIntegrationByName = (slug) => {
  const { integrations: genericIntegration } = useGenericIntegrations();
  const { mappedIntegrations } = useIntegrations();

  const integration = genericIntegration.find((i) => i.slug === slug);
  return integration?.id ? mappedIntegrations[integration.id] : null;
};

export default useGetIntegrationByName;
